import { Check, X, ArrowDownUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const Order = ({ label, list, testid }) => (
  <div className="space-y-1" data-testid={testid}>
    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#7E8E85]">{label}</p>
    <ol className="flex flex-wrap gap-1.5">
      {list.map((x, i) => <li key={x.person_id} className="text-sm px-2.5 py-1 rounded-full bg-[#F4EDE2]"><b className="font-mono text-xs mr-1">{i + 1}.</b>{x.name}</li>)}
    </ol>
  </div>
);

export const OrderRequestCard = ({ o, user, onAction }) => {
  const act = async (kind) => {
    try {
      const { data } = await api.post(`/order-requests/${o.request_id}/${kind}`);
      toast.success(kind === "reject" ? "Suggestion rejected" : data.status === "approved" ? "New order applied to the tree" : "Approval recorded");
      onAction();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const canApprove = user.can_vote && !o.i_approved && (user.is_admin || !o.mine);
  return (
    <div className="rounded-3xl border border-[#C59B27]/40 bg-white p-6 flex flex-col md:flex-row gap-5 md:items-center" data-testid={`order-card-${o.request_id}`}>
      <div className="flex-1 min-w-0 space-y-3">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#8A6A12] flex items-center gap-1"><ArrowDownUp className="w-3 h-3" />Elder → younger order · suggested by {o.requested_by}</p>
        <Order label="Now" list={o.current} testid={`order-current-${o.request_id}`} />
        <Order label="Suggested" list={o.proposed} testid={`order-proposed-${o.request_id}`} />
      </div>
      <div className="md:w-56 space-y-2">
        <p className="text-sm font-medium" data-testid={`order-count-${o.request_id}`}>{o.approvals}/{o.needed} approvals</p>
        <Progress value={(o.approvals / o.needed) * 100} className="h-2" />
        <div className="flex gap-2 pt-1">
          {canApprove && <Button size="sm" onClick={() => act("approve")} className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20]" data-testid={`order-approve-btn-${o.request_id}`}><Check className="w-4 h-4 mr-1" />{user.is_admin ? "Apply now" : "Agree"}</Button>}
          {o.i_approved && <span className="text-xs text-[#2E7D32] self-center">You agreed</span>}
          {user.is_admin && <Button size="sm" variant="outline" onClick={() => act("reject")} className="rounded-full text-[#C62828]" data-testid={`order-reject-btn-${o.request_id}`}><X className="w-4 h-4 mr-1" />Reject</Button>}
        </div>
      </div>
    </div>
  );
};
